const ASSET = "https://static.prod-images.emergentagent.com/jobs/5eff8c1f-b59e-44ca-87ee-9b0bceebb3f3/images/";

export const BRAND = {
  logo: ASSET + "6bc475772d5d5a4a7e8fa4a4a223479848fa2ad825905fb71618c71103ce57fc.jpeg",
  crest: ASSET + "d46fcaf718c819da786a6567b2337ca0e6740de9e81e37afb15cf391007d713d.jpeg",
  heroBoerboel: ASSET + "9eee3cbd229bd93ee21689de48671ca75c41d20753b520c6ad5f4d7460e94b97.jpeg",
  slogan: "EVERYTHING OR NOTHING",
};

export const COMPANY = {
  legalName: "E.O.N INFINITY INC",
  founder: "Herbert Pratt",
  address1: "600 W 6th Street",
  address2: "Suite 442",
  city: "Fort Worth, TX 76102",
  email: "admin@eoninfinity.com",
  phone: "817-692-9093",
  domain: "eoninfinity.com",
};
